import React, { CSSProperties } from 'react';
import { useTranslate } from 'react-admin';

import { Column } from '~/components/VirtualizedList';
import { StatusField, TextField } from '~/components';
import ReferenceField from '~/components/ReferenceField';
import { ApprovalCase } from '~/types/approvalCase';
import { Longdash, time } from '~/utils';

interface Props {
  children: any;
  rowData: ApprovalCase;
  column: Column<ApprovalCase>;
  style?: CSSProperties;
}

const CustomCell = (props: Props) => {
  const { column, children } = props;
  const translate = useTranslate();

  switch (column.id) {
    case 'submittedAt':
    case 'completedAt': {
      if (!children) return <span>{Longdash}</span>;
      const dt = time(children);
      return (
        <TextField compact label={dt.format('LL')}>
          {dt.format('LTS')}
        </TextField>
      );
    }
    case 'object':
    case 'originator':
      return children?.id ? <ReferenceField record={children} /> : null;
    case 'claimedBy':
      return children?.id ? <ReferenceField record={children} /> : <span>{Longdash}</span>;
    case 'status':
      return <StatusField status={children} />;
    case 'actionKey':
      return <span>{children}</span>;
    case 'steps': {
      return (
        <span>
          {translate('resources.approvals.list.stepsProgress', {
            completed: children.currentStep,
            total: children.totalSteps,
          })}
        </span>
      );
    }
    default:
      return null;
  }
};

export default CustomCell;
